import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';


import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  selector: 'app-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class UploadFileDialogComponent implements OnInit {

  file: any;
  /** Nombre del archivo elegido (lo usa, por ejemplo, el corte de SAP). */
  fileName = '';
  jsonData: any[];
  jsonDataLength: number = null;

  constructor(
    public dialogRef: MatDialogRef<UploadFileDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  uploadFile(event: any){
    const target: DataTransfer = <DataTransfer>(event.target);
    const reader = new FileReader();
    this.fileName = target.files[0]?.name ?? '';
    reader.readAsBinaryString(target.files[0]);
    reader.onload = (e) => {
      const data = e.target.result;
      let workBook = XLSX.read(data, { type: 'binary' });
      let sheet1 = workBook.SheetNames[0];
      let sheet = workBook.Sheets[sheet1];
      this.jsonData = XLSX.utils.sheet_to_json(sheet);
      let arrayData = [];
      this.jsonData.forEach((element) => {
        let row = [];
        Object.keys(element).map((r) => {
          row.push(element[r]);
        });
        arrayData.push(row);
      });
      this.jsonDataLength = this.jsonData.length;
    }
  }

  getJsonData(){
    this.dialogRef.close(this.jsonData);
  }

}
